import { platformHandler } from "../platforms/PlatformHandler";

export class SceneManager {
  constructor() {
    this.currentScene = "";
  }

  setHistory(history) {
    this.history = history;
  }

  getCurrentScene() {
    return this.currentScene;
  }

  openScene(scene, params = {}) {
    //Actions.pop();
    //TODO Actions[scene]( params );
    console.log("openScene " + scene);
    if (this.history) {
      this.history.push("/" + scene, params);
    }
    this.currentScene = scene;
  }

  backPressed() {
    switch (this.currentScene) {
      case "ShareOption":
      case "JoinOptions":
      case "SelectPresentation":
      case "PresentationUser":
      case "BlockedUser":
      case "Login":
        this.history.goBack();
        //this.openScene("Role");
        break;
      case "MainMenu":
        /*TODO BELTRAN */
        if (platformHandler.blockExhibitForElectron()) {
          this.openScene("UploadPresentation");
        } else {
          this.openScene("SelectPresentation");
        }
        break;
      case "PluginViewer":
        this.openScene("MainMenu");
        break;
      case "SlideEditor":
        if (platformHandler.slideEditor) {
          platformHandler.slideEditor.backPressed();
        }
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/utils/sceneManager.js